<template>
    <div>
      <span>{{ $t(title) }}</span>
      <br />
      <table class="table table-striped table-hover caption-top tbl-file-manager">
          <caption>{{ $t(description) }}</caption>
          <thead class="table-dark">
            <tr>
              <th scope="col" class="number">#</th>
              <th scope="col" class="identifier">
                {{ $t('fileManager.fileManagerTable.id') }}
              </th>
              <th scope="col">
                {{ $t('fileManager.fileManagerTable.name') }}
              </th>
              <th scope="col" class="size">
                {{ $t('fileManager.fileManagerTable.originalSize') }}
              </th>
              <th scope="col" class="size">
                {{ $t('fileManager.fileManagerTable.processedSize') }}
              </th>
              <th scope="col" class="status">
                {{ $t('fileManager.fileManagerTable.status') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in files" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ file.id }}</td>
              <td>{{ file.name }}</td>
              <td>{{ file.originalSize }}</td>
              <td>{{ file.processedSize }}</td>
              <td>
                  {{$t(`fileManager.statuses.${file.status}`)}}
              </td>
            </tr>
            <tr v-if="files.length == 0">
              <td colspan="6">
                {{ $t(emptyMessage) }}
              </td>
            </tr>
          </tbody>
      </table>      
  </div>
</template>

<script lang="js">

export default {
  name: "FileManager",
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    emptyMessage: {
      type: String,
      default: ''
    },    
    files: {
      type: [],
    },
  },

  mounted() {}
}
</script>

<style lang="scss">
.tbl-file-manager {
  th.number { width: 60px; }
  th.size { width: 185px; }
  th.identifier { width: 200px; }
  th.status { width: 140px; }
}
</style>

